import { withStyles } from '@material-ui/core';

import StatisticAccessField from './component';
import styles from './styles';

export default withStyles(styles)(StatisticAccessField);
